<template>
	<v-dialog v-model="dialog" scrollable persistent max-width="400">
		<CardDialogPersonalizado>
			<p><b>Você realmente deseja excluir esse fornecedor?</b></p>
			<v-row class="mt-2">
				<v-col cols="6">
					<v-btn class="red--text" @click="excluirItens()" large width="100%">
						<v-icon left> mdi-delete </v-icon>
						sim
					</v-btn>
				</v-col>
				<v-col cols="6">
					<v-btn class="white--text mt-pa" @click="fecharDialog()" color="#CC2128" large width="100%">
						<v-icon left> mdi-close </v-icon>
						Não
					</v-btn>
				</v-col>
			</v-row>
		</CardDialogPersonalizado>
	</v-dialog>
</template>

<script>
import CardDialogPersonalizado from '../shared/dialogPersonalizado.vue'

export default {
	props: {
		abrirDialog: Boolean,
		id: String,
	},
	components: {
		CardDialogPersonalizado,
	},
	computed: {
		dialog: {
			get() {
				return this.abrirDialog
			},
			set() {
				this.fecharDialog()
				this.loadFornecedores()
			},
		},
	},
	methods: {
		fecharDialog() {
			this.$emit('fecharDialog')
		},
		async excluirItens() {
			try {
				const response = await this.axios.delete(`/fornecedor/${this.id}`)
				if (response.status == 204) {
					this.loadFornecedores()
					this.$store.dispatch('showSuccess', 'Fornecedor excluído com sucesso!')
					this.fecharDialog()
					this.$emit('fecharTodosDialogs')
				}
				this.fecharDialog()
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
		loadFornecedores() {
			this.$emit('loadFornecedores')
		},
	},
}
</script>

